<template>
    <v-list-item>
        <template>
            <v-form v-model="valid" lazy-validation>
                <v-row>
                    <v-col md="12">
                      <v-text-field
                          label="Template name"
                          v-model="template.name"
                          :rules="rules"
                          hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col md="12">                    
                        <v-text-field
                            label="Email title"
                            v-model="template.title"
                            :rules="rules"
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                    <v-col md="12">
                        <v-textarea 
                            rows="3"
                            v-model="template.text"
                            label="Email text"
                        ></v-textarea>
                    </v-col>
                    <v-col md="12" class="d-flex justify-end">
                        <v-btn color="blue darken-1" text @click="remove">
                            Remove
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="update" :disabled="!this.valid">
                            Save
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </template>
    </v-list-item>
</template>

<script>

import { mapActions, mapMutations } from "vuex";

export default {
    name: "EmailMessageForm",
    props: {
        template: Object,
    },
    data() {
        return {
            valid: true,
            rules: [
                value => !!value || 'Required.',
            ],
        };
    },
    methods: {
        ...mapMutations({
            DELETE_EMAIL: "templates/DELETE_EMAIL",
        }),
        ...mapActions({
            showHandlerSnackbar: "snackbar/showHandlerSnackbar",
        }),
        update() {
            this.$axios.post('/templates/email/update', {
                id: this.template.id,
                name: this.template.name,
                title: this.template.title,
                text: this.template.text,
            }).then(res => {
                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });
            }).catch(e => {
                console.log('error', e);
            });
        },
        remove() {
            this.$axios.post('/templates/email/remove', {
                id: this.template.id,
            }).then(res => {
                this.DELETE_EMAIL(this.template.id);

                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });
            }).catch(e => {
                console.log('error', e);
            });
        }
    },
};

</script>